import { ChangeDetectionStrategy, Component, effect, input, viewChild } from '@angular/core';
import { MarkerComponent } from '@maplibre/ngx-maplibre-gl';
import { applyMarkerOffset } from '@wheere-front/shared-ui';

/**
 * Nom d'une pièce posé sur le plancher de l'étage affiché (bâtiment 3D, ADR-017). `offset` le
 * place à l'altitude du plancher ; `mgl-marker` ne relisant pas son `offset`, il est appliqué au
 * marqueur MapLibre.
 */
@Component({
  selector: 'lib-map-room-label',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MarkerComponent],
  template: `
    <mgl-marker [lngLat]="[lon(), lat()]">
      <div
        class="text-midnightBlue-500 pointer-events-none whitespace-nowrap text-center text-[11px] font-black uppercase tracking-wider [text-shadow:0_0_3px_#fff,0_0_3px_#fff,0_0_6px_#fff]">
        {{ name() }}
        @if (showArea() && areaM2() !== null) {
          <span class="block text-[10px] font-bold normal-case tracking-normal text-gray-600">{{ areaM2() }} m²</span>
        }
      </div>
    </mgl-marker>
  `,
})
export class MapRoomLabelComponent {
  name = input.required<string>();
  lat = input.required<number>();
  lon = input.required<number>();
  areaM2 = input<number | null>(null);
  showArea = input(false);
  offset = input<[number, number] | null>(null);
  private readonly mglMarker = viewChild(MarkerComponent);

  constructor() {
    effect(() => {
      const offset = this.offset();
      const marker = this.mglMarker()?.markerInstance();
      applyMarkerOffset(marker, offset);
    });
  }
}
